import React from 'react'
import FullCalendar from '@fullcalendar/react'
import { formatDate } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import AdminLeftMenu from './backend/AdminLeftMenu';
import { Link, useOutletContext } from 'react-router-dom';
import PractitionerService from '../services/practitionerService';
import centralAppointmentService from '../services/centralAppointmentService';

let resObject = [];

// Wrapper component to use hooks
const CalendarWrapper = () => {
  const [userData, currentUser] = useOutletContext();
  return <Calendar currentUser={currentUser} userData={userData} />;
};

class Calendar extends React.Component {
  state = {
    weekendsVisible: true,
    currentEvents: [],
    calEvent: [],
    event: {
      id: "",
      title: "",
      start: "",
      start_date: ""
    },
    isLoading: false
  }

  constructor(props) {
    super(props);
    this.practitionerService = new PractitionerService();
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }



  async componentDidMount() {
    const { currentUser } = this.props;
    
    if (!currentUser?.uid) {
      // No user logged in, show empty calendar
      this.setState({ calEvent: [] });
      return;
      }

    try {
      this.setState({ isLoading: true });
      
      // Get real saved practitioners from Firebase
      const savedPractitioners = await this.practitionerService.getSavedPractitioners(currentUser.uid);
      
      if (savedPractitioners && savedPractitioners.length > 0) {
        // Use centralized service for calendar events WITH userId for Firebase appointments
        const calendarEvents = await centralAppointmentService.getCalendarEvents(savedPractitioners, currentUser.uid);
        const appointments = await centralAppointmentService.getAllAppointments(savedPractitioners, false, currentUser.uid);
        
        // Update global variables for compatibility
        resObject = appointments;
        localStorage.setItem('alldata', JSON.stringify(appointments));
        
        this.setState({ calEvent: calendarEvents });
        } else {
        // No saved practitioners, show empty calendar
        resObject = [];
        this.setState({ calEvent: [] });
      }
    } catch (error) {
      console.error('Error loading calendar appointments:', error);
      resObject = [];
      this.setState({ calEvent: [] });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    return (
      <div className='demo-app'>
        {this.renderSidebar()}
        <div className='demo-app-main'>
          {this.state.isLoading ? (
            <div className="text-center p-4">
              <div className="loading-spinner-container">
                <div className="loading-spinner"></div>
                <p>Loading calendar...</p>
              </div>
            </div>
          ) : this.state.calEvent.length === 0 ? (
            <div className="text-center p-4">
              <div className="py-4">
                <i className="fa fa-calendar fa-3x text-muted mb-3"></i>
                <h5>No Appointments Scheduled</h5>
                <p className="text-muted">Add physicians to see their appointments here.</p>
                <Link to="/physicians" className="btn btn-primary">
                  <i className="fa fa-plus me-2"></i>Add Physicians
                </Link>
              </div>
            </div>
          ) : (
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            initialView='dayGridMonth'
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={this.state.weekendsVisible}
            eventContent={renderEventContent} // custom render function
            eventClick={this.handleEventClick}
            eventsSet={this.handleEvents}
            select={this.handleDateSelect}
            events={this.state.calEvent}// called after events are initialized/added/changed/removed
            height="auto"
            aspectRatio={1.35}
          /* you can update a remote database when these fire:
          eventAdd={function(){}}
          eventChange={function(){}}
          eventRemove={function(){}}
          */
          />
          )}
        </div>
      </div>
    )
  }

  renderSidebar() {
    return (
      <>
        <div className="offcanvas offcanvas-start" id="demo">
          <AdminLeftMenu />
        </div>
      </>
    )
  }

  handleDateSelect = (selectInfo) => {
    const title = prompt('Please enter a new title for your event')
    if (title) {
      // Future enhancement: handle event creation
    }
    let calendarApi = selectInfo.view.calendar
    calendarApi.unselect() // clear date selection
  }

  handleEvents = (events) => {
    this.setState({
      currentEvents: events
    });
  }

  handleEventClick = (info) => {
    // Check if resObject exists and is an array
    if (!resObject || !Array.isArray(resObject) || resObject.length === 0) {
      console.log("No physician data available");
      return;
    }

    // window.confirm(info).push({
    for (let j = 0; j < resObject.length; j++) {

      const date = info.event.start

      let years = date.getFullYear()
      let month = (date.getMonth() + 1)
      let day = date.getDate()

      let newMonth;

      let newDay;

      if (month<10) {
        newMonth = "0" + month
      }else{
        newMonth=month
      }

      if (day<10) {
        newDay = "0" + day
      }else{
        newDay=day
      }

      let newDate = years + "-" + newMonth + "-" + newDay
    
              if (newDate === resObject[j].start_date) {
        console.log("date==" + newDate + "==" + resObject[j].start_date);
        localStorage.setItem('event', JSON.stringify(resObject[j]));
        break;
      }
    }
    window.location.href = "/schedule/";
    // this.setState({ event: info })
  }
}

function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b>
      <i>{eventInfo.event.title}</i>
    </>
  )
}



export default CalendarWrapper;

